import api from '../api/api.index';
import renderFilters from './feed.render.filters';
import renderPosts from './feed.render.posts';
import renderPagination from './feed.render.pagination';
import renderDraw from './feed.render.draw';
import renderUrl from './feed.render.url';
import renderDataLayer from './feed.render.data-layer';

/**
 * Processes the feed data.
 * @param {boolean} firstLoad - Indicates if it's the first load.
 */
const process = async (firstLoad) => {
	// Add Bootstrap spinner while loading
	const feedContainer = document.querySelector('.js-gsfc-feed');
	feedContainer.innerHTML =
		'<strong class="govuk-heading-s mt-2">Loading&hellip;</strong></div>';

	// Hide pagination while loading
	const paginationFilters = document.querySelector(
		'.js-gsfc-feed-pagination'
	);
	paginationFilters.innerHTML = '';

	const feed = await api.getFeed();

	if (!firstLoad) {
		renderUrl();
	}

	renderPosts(feed);
	renderFilters(feed);
	renderPagination(feed);
	renderDraw();
	renderDataLayer(global.filters);
};

// Export the process function
export default { process };
